import { useCallback, useMemo } from "react";
import type { AtmosphereWinterWheelsType } from "../../utils/types/AtmosphereType";
import type { CarConfigDispatchType } from "../../redux/store";
import { useCarConfigSelector } from "../../redux/store";
import { setWinterWheel } from "../../redux/slices/CarConfigBasketSlice";
import { trackWinterWheelAddToBasket, trackWinterWheelRemoveFromBasket } from "../../utils/tracking";
import { useDispatch } from "../../../../../shared-logic/redux/store";
import { setActiveSpin, SpinnerType } from "../../redux/slices/CarConfigSpinNavigationSlice";

const useAphLbxWinterWheel = (
    wheel: AtmosphereWinterWheelsType,
    categoryName: string,
): { onClick: () => void; isSelectable: boolean; isActive: boolean } => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const carWinterWheels = useCarConfigSelector((state) => state.items.winterWheels);
    const basketWinterWheel = useCarConfigSelector((state) => state.basket.winterWheel);

    const currentWinterWheel = carWinterWheels.find((carWheel) => carWheel.id === wheel.id);
    const activeSpinner = useCarConfigSelector((state) => state.carConfigSpinNavigation.activeSpin);

    const activeGrade = useCarConfigSelector((state) => state.car.grade);
    const activeAtmosphere = useCarConfigSelector((state) =>
        state.carConfigAtmosphere.atmospheres.find((atmosphere) => atmosphere.id === activeGrade?.id),
    );
    const isWheelFromActiveGrade = categoryName === activeAtmosphere?.category;

    const isActive = useMemo(() => {
        return wheel.id === basketWinterWheel?.id && isWheelFromActiveGrade;
    }, [basketWinterWheel, wheel.id, isWheelFromActiveGrade]);

    const onClick = useCallback(() => {
        if (activeSpinner !== SpinnerType.Car) {
            dispatch(setActiveSpin(SpinnerType.Car));
        }
        if (currentWinterWheel) {
            if (isActive) {
                trackWinterWheelRemoveFromBasket();
                dispatch(setWinterWheel(null));
            } else {
                trackWinterWheelAddToBasket();
                dispatch(setWinterWheel(currentWinterWheel));
            }
        }
    }, [currentWinterWheel, activeSpinner, isActive, dispatch]);

    const isSelectable = useMemo(() => {
        return !!currentWinterWheel && isWheelFromActiveGrade;
    }, [currentWinterWheel, isWheelFromActiveGrade]);

    return {
        onClick,
        isSelectable,
        isActive,
    };
};

export default useAphLbxWinterWheel;
